import { defineStore } from 'pinia'

import type { PaidStore } from './interfaces'

import { AllLessonsSwitcher } from './enums'
import { actions } from './actions'
import { getters } from './getters'

export const usePaidStore = defineStore('paid', {
  state: (): PaidStore => ({
    isChangeTutorModalOpen: false,
    isChangeTutorSuccessModalOpen: false,
    modalUpsell: false,
    loading: false,
    processing: false,
    modalReschedule: null,
    modalFirstLessonAttend: null,
    firstLessonAttendPending: false,
    modalCancel: null,
    rescheduleDate: null,
    rescheduleTime: null,
    availableSlots: null,
    bookingDate: null,
    triggerRescheduleSelect: 0,
    allLessonsSwitcher: AllLessonsSwitcher.Upcoming,
  }),
  actions,
  getters,
})
